import { render, staticRenderFns } from "./ClubJiansheGradeList.vue?vue&type=template&id=440652a4&"
import script from "./ClubJiansheGradeList.vue?vue&type=script&lang=js&"
export * from "./ClubJiansheGradeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports